<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="900">
            <v-card>
                <v-card-title class="text-h6" v-if="propAdd == 'tambah'">Tambah Kategori E-Learning</v-card-title>
                <v-card-title class="text-h6" v-else>Edit Kategori E-Learning</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <v-row>
                                <v-col cols="12" sm="12" md="12" class="pb-0">
                                    <v-text-field class="w-md-75" outlined dense @focus="() => konfirmResponse.name = ''" :error-messages="konfirmResponse.name"
                                        v-model="paramAdd.name" label="Nama Kategori"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12" class="pb-0 ml-2">
                                    <label>Pilih Warna Tag Kategori</label>
                                    <v-color-picker class="pt-2" dot-size="22" hide-mode-switch mode="hexa" @focus="() => konfirmResponse.color = ''"
                                        :error-messages="konfirmResponse.color" v-model="paramAdd.color"></v-color-picker>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" outlined @click="batal" class="text-capitalize">Batal</v-btn>
                    <v-btn color="primary" depressed @click="simpan" class="text-capitalize">Simpan</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar" :timeout="timeout" right top :color="snackbarClass">
            {{ text }}
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-row>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
export default {
    data() {
        return {
            page: 1,
            limit: "10",
            params: [],
            area_selected: '',
            provinsi: '',
            kota: '',
            subdistrict_selected: '',
            snackbarClass: "green accent-4",
            snackbar: false,
            text: "",
            timeout: 2000,
            paramAdd: {
                name: '',
                color: '',
            },
        }
    },
    props: {
        value: Boolean,
        propAdd: String,
        edit: String,
        val: Object
    },
    computed: {
        ...mapState('tutorialCategory', ['konfirmResponse', 'responSukses']),
        dialog: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    methods: {
        ...mapActions('tutorialCategory', ['getTutorialCategory', 'addTutorialCategory', 'updateTutorialCategory']),
        ...mapMutations('tutorialCategory', ['konfirmasiSukses']),
        batal() {
            this.dialog = false
            this.konfirmResponse.name = ''
            this.konfirmResponse.color = ''
        },
        simpan() {
            if(this.propAdd == 'tambah') {
                this.paramAdd.color = this.paramAdd.color['hex'];
            } else {
                this.paramAdd.color = this.paramAdd.color;
            }
            
            if (this.paramAdd) {
                if (this.propAdd == 'tambah') {
                    this.addTutorialCategory(this.paramAdd).then(() => {
                        if (this.responSukses.code == 200) {
                            this.getTutorialCategory({ limit: this.limit, page: 1, params: this.params })
                            this.dialog = false
                            this.reset()
                        }
                    })
                } else {
                    this.updateTutorialCategory(this.paramAdd).then(() => {
                        if (this.responSukses.code == 200) {
                            this.getTutorialCategory({ limit: this.limit, page: 1, params: this.params })
                            this.dialog = false
                            this.reset()
                        }
                    })
                }
            }
        },
        reset() {
            this.konfirmasiSukses('')
            this.paramAdd.name = ''
            this.paramAdd.color = ''
            this.konfirmResponse.name = ''
            this.konfirmResponse.color = ''
        }
    },
    watch: {
        val() {
            this.paramAdd.id = this.val.tutorial_category_id
            this.paramAdd.name = this.val.tutorial_category_name
            this.paramAdd.color = this.val.tutorial_category_color
        }
    }
}
</script>
